<template>
  <!-- 内ユーザー登録 -->
  <div id="InternalUserAdd">
    <div id="container">
      <masterNavi v-bind:pageid='"UserManage"'></masterNavi>
      <div class="labelTitle lable">ユーザー管理</div>
      <userNavi v-bind:pageid='"InternalUserSearch"'></userNavi>
      <div class="labelTitle lable">内部ユーザー追加</div>
      <!--登録内容 -->
      <div>
        <div id="item-contens">
          <div class="card-content margin-top">
            <table>
              <tr><th>【ユーザー情報】</th><td></td></tr>
              <tr>
                <th>権限<span class="require" /></th>
                <td>
                  <select v-model="data.kind" class="validate" name="権限"  validate="required">
                    <option v-for="auth of authorityMaster" :value="auth.code" :key="'s' + auth.code">
                      {{auth.name}}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>ユーザー名<span class="require" /></th>
                <td>
                  <input class="nameInput validate" type="text" v-model="data.lastName" placeholder="姓" name="ユーザー名（姓）" validate="required" maxlength="50"/><input class="nameInput validate" type="text" v-model="data.firstName" placeholder="名" name="ユーザー名（名）" validate="required" maxlength="50"/>
                </td>
              </tr>
              <tr>
                <th>ユーザー名（カナ）<span class="require" /></th>
                <td>
                  <input class="nameInput validate" type="text" v-model="data.lastNameKana" placeholder="セイ" validate="required|kana" name="ユーザー名（姓カナ）" maxlength="50"/><input class="nameInput validate" type="text" v-model="data.firstNameKana" placeholder="メイ" validate="required|kana" name="ユーザー名（名カナ）" maxlength="50"/>
                </td>
              </tr>
              <tr>
                <th>メールアドレス<span class="require" /></th>
                <td>
                  <input type="text" v-model="data.mail" class="validate" name="メールアドレス" validate="required|mail" maxlength="100"/></td>
              </tr>
              <tr>
                <th>メールアドレス（確認）<span class="require" /></th>
                <td>
                  <input type="text" v-model="mailconfirm" class="validate" name="メールアドレス（確認）" validate="required" maxlength="100"/></td>
              </tr>
              <tr>
                <th>連絡先(直通)<span class="require" /></th>
                <td>
                  <input
                    type="text"
                    v-model="data.mobileNumber"
                    class="validate"
                    :class="{'border-red': invalidPhoneNumber}"
                    validate="required|numeric"
                    name="連絡先(直通)"
                    maxlength="11"
                    :placeholder="phonePlaceholder"
                  />
                  <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                </td>
              </tr>
              <tr>
                <th>所属<span class="require" /></th>
                <td>
                  <select v-model="data.office" class="validate" name="所属"  validate="required">
                    <option v-for="office of salesOfficeMaster" :value="office.code" :key="'s' + office.code">
                      {{office.name}}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>営業員コード</th>
                <td><input type="text" v-model="data.salesStaffCode" name="営業員コード" maxlength="10"/></td>
              </tr>
            </table>
          </div>
          <div class="searchButton-area" style="margin-bottom:10px;">
            <b-button class="is-primary" @click="addInternalUser">追加</b-button>
            <b-button class="backButton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  invalidNumberMessage,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
export default {
  name: "InternalUserAdd",
  methods: {
    back: function() {
      this.$router.push({
        name: "InternalUserSearch",
        params: {searchConditions: this.searchConditions}
      });
    },
    addInternalUser: function(){
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if(this.data.mail != this.mailconfirm){
          this.showErrorMessage("メールアドレス(確認)が一致しません。");
          return;
        }
        // Web Api Call
        var _this = this;
        var body = this.createBody();
        this.apiCall(
          function(client){
            return client.apis.internalMaintenance.setMaintenanceInternalUserAdditionPOST({
              body:body
            });
          },
          async function(result){
              _this.showSuccess(result, function(){
              //前画面に戻る
              _this.back();
            });
          },
          function(result){
            _this.showErrorMessage(result);
          }
        ); 
      }
    },
    createBody: function(){
      let userInfo = {
        userId: 0,
        kind:this.data.kind,
        lastName:this.data.lastName,
        firstName:this.data.firstName,
        lastNameKana:this.data.lastNameKana,
        firstNameKana:this.data.firstNameKana,
        mail:this.data.mail,
        phoneNumber:this.data.mobileNumber,
        office: this.data.office,
        salesStaffCode: this.data.salesStaffCode
      };
      return userInfo;
    }
  },
  data() {
    var searchConditions = this.$route.params["searchConditions"];
    var salesOfficeMaster = this.getSalesOfficeMaster();
    var authorityMaster = this.getAuthorityMaster();
    authorityMaster = authorityMaster.filter(function(auth) {
      return auth.type == 'inner';
    });
    return {
      salesOfficeMaster:salesOfficeMaster,
      authorityMaster:authorityMaster,
      data: {},
      mailconfirm: "",
      searchConditions,
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar,
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data.mobileNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
.nameInput {
  width: 463px !important;;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/user/InternalUserAdd.vue